module.exports = __webpack_public_path__ + "static/media/24.11224a39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/24.jpg
// module id = 585
// module chunks = 0